// // List of checklists
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import APIService from '../../../Services/APIService';
// import SweetAlert from '../../Shared/Notification';
// import TableHeader from '../../Shared/TableHeader';
// import LoadingWrapper from '../../Shared/LoadingWrapper';
// import CommonTable from '../../Shared/Tables';
// import DataNotFound from '../../Shared/DataNotFound';
// import { Button, Col, Row } from 'react-bootstrap';
// import ReactPagination from '../../Shared/Pagination';
// import SearchBox from '../../Shared/SearchBox';
// import ConfirmBox from '../../Shared/Notification/ConfirmBox';

// const baseInventoryList = () => {
//   const navigate = useNavigate();
//   const [list, setList] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [filters, setFilters] = useState({ search: '', page: 0, totalCount: 0 });

//   const columns = [
//     {
//       dataField: 'index',
//       text: 'S.No.',
//       formatter: (cell, row, rowIndex) => rowIndex + 1,
//       headerAlign: 'center',
//       align: 'center',
//     },
//     {
//       dataField: 'name',
//       text: 'Name',
//       headerAlign: 'center',
//       align: 'center',
//     },
//     {
//       dataField: 'action',
//       text: 'Action',
//       headerAlign: 'center',
//       align: 'center',
//       formatter: (cell, row, rowIndex) => {
//         return (
//           <>
//             <Link to={`/r/inventory/base/edit/${row._id}`} className="btn btn--danger">
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   fill="currentColor"
//                   className="bi bi-pencil-fill"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
//                 </svg>
//               </span>
//             </Link>
//             <span
//               style={{ cursor: 'pointer' }}
//               onClick={(e) => deleteBaseInventory(row?._id, rowIndex)}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="16"
//                 height="16"
//                 fill="currentColor"
//                 className="bi bi-trash-fill"
//                 viewBox="0 0 16 16"
//               >
//                 <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
//               </svg>
//             </span>
//           </>
//         );
//       },
//     },
//   ];

//   const getBaseInventory = async (data) => {
//     setIsLoading(true);
//     let res = await APIService.get(
//       `/v0/ui/dynamic-inventory/base-inventory/?next_page=${data?.page + 1}&search=${data?.search}`
//     );
//     if (res.status == 200) {
//       setList(res.data?.list);
//       setFilters({ ...filters, page: data?.page, totalCount: res?.data?.count });
//     }
//     setIsLoading(false);
//   };

//   const deleteBaseInventory = async (id) => {
//     const confirmed = await ConfirmBox({
//       title: 'Confirm Deletion',
//       text: 'Are you sure you want to delete this inventory?',
//       icon: 'warning',
//     });
//     if (confirmed) {
//     let res = await APIService.remove(`/v0/ui/dynamic-inventory/base-inventory/${id}/`);
//     if (res.status == 200) {
//       let filterData = list.filter((item) => item._id != id);
//       setList(filterData);
//       SweetAlert('Base inventory deleted successfully', 'success');
//     }
//   }
// };

//   const onPageChange = (e) => {
//     getBaseInventory({ ...filters, page: e?.selected });
//   };
//   const onSearchFilterChange = (e) => {
//     getBaseInventory({ ...filters, search: e });
//   };

//   useEffect(() => {
//     getBaseInventory(filters);
//   }, []);

//   return (
//     <>
//       <TableHeader headerValue={'All Organisation - Inventory Standard Templates'} />
//       <Row>
//         <Col xs="3" className="pb-3">
//           <SearchBox onSearch={onSearchFilterChange} value={filters?.search} />
//         </Col>{' '}
//         <Col xs="3" className="pb-2">
//           <Button
//             onClick={() => {
//               navigate('/r/inventory/base/create/');
//             }}
//           >
//             Create
//           </Button>
//         </Col>{' '}
//       </Row>
//       {isLoading ? (
//         <LoadingWrapper />
//       ) : list?.length > 0 ? (
//         <>
//           {' '}
//           <CommonTable id={'_id'} columnsData={columns} rowData={list} />
//           <ReactPagination
//             pageNo={filters?.page}
//             pageSize={20}
//             totalItems={filters?.totalCount}
//             onPageChange={onPageChange}
//           />
//         </>
//       ) : (
//         <DataNotFound message="No base inventory available. Create your first one now!" />
//       )}
//     </>
//   );
// };
// export default baseInventoryList;

// List of checklists

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import Pagination from '../../FlowBuilder/Common/Pagination/index.tsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import useDebounce from '../../Shared/Delay/index.tsx';

const baseInventoryList = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({ search: '', page: 0, limit: 20, totalCount: 0 });
  const { showSnackBar } = useSnackBar();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const debouncedSearch = useDebounce(filters.search, 500);

  const columns = [
    {
      header: 'S.No.',
      accessorKey: 'index',
      Cell: ({ row }) => row.index + 1,
      enableSorting: false,
      size: 50,
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableSorting: false,
      size: 50,
    },
    {
      header: 'Action',
      accessorKey: 'action',
      enableSorting: false,
      size: 50,
      Cell: ({ row }) => {
        const info = row.original;
        return (
          <Box display="flex" justifyContent="flex-start" gap={1}>
            <Link to={`/r/inventory/base/edit/${info._id}`}>
              <IconButton size="small">
                <EditIcon />
              </IconButton>
            </Link>
            <IconButton
              size="small"
              onClick={() => {
                setDeleteId(info._id);
                setConfirmOpen(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleConfirmClose = async (confirmed) => {
    setConfirmOpen(false);
    if (confirmed && deleteId) {
      let res = await APIService.remove(`/v0/ui/dynamic-inventory/base-inventory/${deleteId}/`);
      if (res.status == 200) {
        let updatedList = list.filter((item) => item._id !== deleteId);
        setList(updatedList);
        showSnackBar('Base inventory deleted successfully', 'success');
      }
      setDeleteId(null);
    } else {
      setDeleteId(null);
    }
  };

  const onPageChange = (e, newPage) => {
    getBaseInventory({ ...filters, page: newPage });
  };

  const onRowsPerPageChange = (e) => {
    setFilters({ ...filters, limit: e.target.value, page: 0 });
    getBaseInventory({ ...filters, limit: e.target.value, page: 0 });
  };

  const getBaseInventory = async (data) => {
    setIsLoading(true);
    let res = await APIService.get(
      `/v0/ui/dynamic-inventory/base-inventory/?next_page=${data?.page + 1}&search=${data?.search}&pageSize=${data?.limit}`
    );
    if (res.status == 200) {
      setList(res.data?.list);
      setFilters({ ...filters, page: data?.page, totalCount: res?.data?.count });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getBaseInventory({ ...filters, search: debouncedSearch });
  }, [debouncedSearch, filters.page, filters.limit]);

  const onSearchFilterChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
      page: 0,
    }));
  };

  useEffect(() => {
    getBaseInventory(filters);
  }, []);

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', p: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            All Organisation - Inventory Standard Templates
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ alignItems: 'center', pt: 2, pb: 2.5, gap: 2 }}
        className="search-box-style"
      >
        <Grid item xs={12} sm={6} md={2}>
          <SearchBox handleSearch={onSearchFilterChange} value={filters?.search} />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              navigate('/r/inventory/base/create/');
            }}
          >
            Create
          </Button>
        </Grid>
      </Grid>
      <CommonTable
        columns={columns}
        data={list}
        isLoading={isLoading}
        renderBottomToolbar={() => (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0 }}>
            <Pagination
              totalCount={filters?.totalCount}
              rowsPerPage={filters?.limit}
              page={filters?.page}
              handleChangePage={onPageChange}
              handleChangeRowsPerPage={onRowsPerPageChange}
            />
          </Box>
        )}
      />
      <ConfirmBox
        open={confirmOpen}
        onClose={handleConfirmClose}
        options={{
          title: 'Confirm Deletion',
          text: 'Are you sure you want to delete this inventory?',
          confirmButtonText: 'Delete',
          confirmButtonColor: 'error',
        }}
      />
    </Box>
  );
};
export default baseInventoryList;
